<template lang="pug">
modal#request-signature-sent-modal(
  :process-button-label='$t("button.ok")'
  :showCancelButton='false'
  :title='$t("modal.requestSignatureSentModal.title")'
  @process='closeModal'
  ref='modal'
)
  .text {{ $t('modal.requestSignatureSentModal.message') }}
  .text-center.my-4
    img.img-fluid(src='/img/ilustrations/request-signature-sent.svg')
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';

export default {
  name: 'RequestSignatureSentModal',
  components: {
    Modal,
  },
  methods: {
    closeModal() {
      this.$refs.modal.close();
    },
  },
};
</script>
